import { render, staticRenderFns } from "./creator-workouts.vue?vue&type=template&id=51819937&"
import script from "./creator-workouts.vue?vue&type=script&lang=js&"
export * from "./creator-workouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports